import { type ReactElement } from 'react'
import { ErrorBox } from '../ErrorBox'

interface GlobalAuthErrorProps {
  error: string | undefined
}

export function GlobalAuthError ({ error }: GlobalAuthErrorProps): ReactElement {
  return (
    <div className="flex justify-center items-center w-full h-screen">
      <div className="w-2/3 md:w-96 h-96 md:h-1/2">
        <ErrorBox error={error}>
          Global Auth Error
        </ErrorBox>
      </div>
    </div>
  )
}
